import React from "react";
import { Settings, LayoutGrid, Users, Tags, Palette, Keyboard, Crown, Calendar, Mail, Bot, UserCircle } from "lucide-react";
import { SettingsTab } from "./types";

interface SettingsTabsProps {
  activeTab: SettingsTab;
  onTabChange: (tab: SettingsTab) => void;
}

const tabs: { id: SettingsTab; label: string; icon: React.ReactNode }[] = [
  { id: "general", label: "General", icon: <Settings size={18} /> },
  { id: "lists", label: "My lists", icon: <LayoutGrid size={18} /> },
  { id: "sharedLists", label: "Shared with me", icon: <Users size={18} /> },
  { id: "tags", label: "Tags", icon: <Tags size={18} /> },
  { id: "appearance", label: "Appearance", icon: <Palette size={18} /> },
  { id: "shortcuts", label: "Shortcuts", icon: <Keyboard size={18} /> },
  { id: "subscription", label: "Subscription", icon: <Crown size={18} /> },
  { id: "calendar", label: "Calendar", icon: <Calendar size={18} /> },
  { id: "email", label: "Email", icon: <Mail size={18} /> },
  { id: "agents", label: "Agents", icon: <Bot size={18} /> },
  { id: "account", label: "Account", icon: <UserCircle size={18} /> },
];

const SettingsTabs: React.FC<SettingsTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="md:w-48 md:border-r md:border-b-0 border-b border-warm-border md:pr-4 md:pb-0 pb-2 flex-shrink-0">
      <nav className="flex md:flex-col gap-1 overflow-x-auto scrollbar-hide -mx-1 px-1 md:overflow-visible md:mx-0 md:px-0">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-shrink-0 md:w-full flex items-center gap-2 md:gap-3 px-3 py-2 rounded-lg text-sm transition-colors whitespace-nowrap ${
              activeTab === tab.id
                ? "bg-warm-blue-dark text-white"
                : "text-warm-text-secondary hover:bg-warm-bg-elevated hover:text-warm-text-primary"
            }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default SettingsTabs;
